/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSettingScopeFromJSON, StreemApiSettingScopeToJSON, } from './';
export function StreemApiSaveCompanySettingRequestFromJSON(json) {
    return StreemApiSaveCompanySettingRequestFromJSONTyped(json, false);
}
export function StreemApiSaveCompanySettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': !exists(json, 'value') ? undefined : json['value'],
        'filterToScope': !exists(json, 'filter_to_scope') ? undefined : StreemApiSettingScopeFromJSON(json['filter_to_scope']),
    };
}
export function StreemApiSaveCompanySettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'filter_to_scope': StreemApiSettingScopeToJSON(value.filterToScope),
    };
}
//# sourceMappingURL=StreemApiSaveCompanySettingRequest.js.map